import {EntityBase} from "../../../shared/entity/EntityBase";
import {PASS_TYPE} from "../../../shared/utils/enum";
import dayjs from "dayjs";

const PASS_MASTER_FIELDS = {
    seq: { type: Number, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    passType: { type: Number, defaultValue: PASS_TYPE.MONTHLY }, // 1: 월간, 2: 주간
    name: { defaultValue: '' },
    begin: { type: Number, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: Number, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    onOff: { type: Number, defaultValue: 0 }, // 0: off, 1: on
}

export class PassMasterEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PASS_MASTER_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
            {condition: () => this.passType === 0, message: '패스 타입이 없습니다.'},
        ];
    }
}